"use client";

import * as stylex from "@stylexjs/stylex";
import { ArrowLeft, ArrowRight, ScanEye } from "lucide-react";
import "@/colors.stylex";
import { colors } from "@/colors.stylex";
import { DirectHapticTarget } from "@/components/direct-haptic-target";
import { useMokaMatchContext } from "@/components/moka-match/moka-match-root";
import { Button } from "@/components/ui/button";
import { buttonStyles } from "@/components/ui/button-variants";
import { Spinner } from "@/components/ui/spinner";
const styles = {
  historyButton: {
    kzqmXN: "xb1qrhf",
    kZKoxP: "x12hms15",
    kmuXW: "x2lah0s",
    $$css: true
  },
  analyzeButton: {
    kmuXW: "x2lah0s",
    k1C7PZ: "x1d3i0y6",
    kg3NbH: "x97vtpp x1ritccj",
    $$css: true
  },
  compactButton: {
    kmuXW: "x2lah0s",
    kg3NbH: "x97vtpp x1ritccj",
    $$css: true
  },
  passTarget: {
    k1xSpc: "x3nfvp2",
    kmuXW: "x2lah0s",
    kaIpWk: "xtkphhm",
    kMeerF: "x1odlxkb",
    k3XXqK: "x1t137rt xnnj0qo",
    kInvED: "xdjuwb3",
    kjBf7l: "x1a1hf4r",
    $$css: true
  },
  passButtonFace: {
    kfzvcC: "x47corl",
    kmuXW: "x2lah0s",
    kg3NbH: "x97vtpp x1ritccj",
    $$css: true
  },
  dimmed: {
    kSiTet: "x197sbye",
    $$css: true
  },
  debugPlayButton: {
    koQZXg: "x8x9d4c",
    kmuXW: "x2lah0s",
    kg3NbH: "xnxx81d",
    $$css: true
  }
};
const MokaMatchHistoryControls = () => {
  const {
    canRedo,
    canUndo,
    goToNextPosition,
    goToPreviousPosition
  } = useMokaMatchContext();
  return <div className="x78zum5 x6s0dn4 x4prdry">
      <Button aria-label="Previous position" disabled={!canUndo} onClick={goToPreviousPosition} size="icon" styles={styles.historyButton} title="Previous position" type="button" variant="outline">
        <ArrowLeft aria-hidden="true" className="xcdlrvm x1l36t39" />
      </Button>
      <Button aria-label="Next position" disabled={!canRedo} onClick={goToNextPosition} size="icon" styles={styles.historyButton} title="Next position" type="button" variant="outline">
        <ArrowRight aria-hidden="true" className="xcdlrvm x1l36t39" />
      </Button>
    </div>;
};
MokaMatchHistoryControls.displayName = "MokaMatchHistoryControls";
const MokaMatchPassButton = () => {
  const {
    doesNeedDirectHapticTarget,
    isBoardDisabled,
    passTurn
  } = useMokaMatchContext();
  if (doesNeedDirectHapticTarget) {
    return <DirectHapticTarget accessibleLabel="Pass" disabled={isBoardDisabled} onActivate={() => passTurn(true)} styles={styles.passTarget}>
        <span aria-hidden="true" {...stylex.props(buttonStyles.base, buttonStyles.sizeDefault, buttonStyles.variantDefault, styles.passButtonFace, isBoardDisabled && styles.dimmed)}>
          Pass
        </span>
      </DirectHapticTarget>;
  }
  return <Button disabled={isBoardDisabled} onClick={() => passTurn()} size="default" styles={styles.compactButton} type="button">
      Pass
    </Button>;
};
MokaMatchPassButton.displayName = "MokaMatchPassButton";
const MokaMatchActionControls = () => {
  const {
    isAnalysisLoading,
    isAnalysisModePinned,
    isBoardDisabled,
    startNewGame,
    toggleAnalysisMode
  } = useMokaMatchContext();
  return <div className="x8x9d4c x78zum5 x6s0dn4 x4prdry">
      <Button aria-pressed={isAnalysisModePinned} disabled={isBoardDisabled} onClick={toggleAnalysisMode} size="default" styles={styles.analyzeButton} title={isAnalysisModePinned ? "Hide analysis" : "Analyze position"} type="button" variant="outline">
        {isAnalysisLoading ? <Spinner aria-hidden="true" /> : <ScanEye aria-hidden="true" className="xcdlrvm x1l36t39" />}
        Analyze
      </Button>
      <MokaMatchPassButton />
      <Button onClick={startNewGame} size="default" styles={styles.compactButton} type="button" variant="outline">
        New game
      </Button>
    </div>;
};
MokaMatchActionControls.displayName = "MokaMatchActionControls";
const MokaMatchControls = () => {
  const {
    isDebugMode,
    position,
    startPlayableGame
  } = useMokaMatchContext();
  return <div className="x78zum5 xh8yej3 x1a02dak x6s0dn4 x1nhvcw1 xsin8gy x1rnwn48">
      {!isDebugMode && <>
          <MokaMatchHistoryControls />
          <MokaMatchActionControls />
        </>}

      {isDebugMode && !position.isGameComplete && <Button onClick={startPlayableGame} size="default" styles={styles.debugPlayButton} type="button">
          Play against Moka
        </Button>}
    </div>;
};
MokaMatchControls.displayName = "MokaMatchControls";
export { MokaMatchControls };